import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/totalBets.css';
// helpers
import {OPERATOR} from '../../../../constants/operator';
import {getFormattedCurrency, getText} from '../../../../helpers/localization';
import {fakePlaceBets, placeAndClearOpenBets} from '../../helpers/betHelpers';
import {clearEventOpenBets} from '../../../../actions/eventsActions';

const mapStateToProps = (state, ownProps) => {
    return {games: state.vpp.games, openBetsList: state.vpp.openBetsList};
};

class TotalBets extends Component {
    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            openBetsList: storeData.vpp.openBetsList
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();

        this.setState({games: storeData.vpp.games, openBetsList: storeData.vpp.openBetsList});
    }

    render() {
        let totalBetsValue = 0;
        this.state.openBetsList.map(openBet => {
            return totalBetsValue += openBet.stake;
        });
        totalBetsValue = totalBetsValue / 100;

        let data = this.props.store.getState().vpp;
        let isTimeToShowLoading = !!this.state.games[data.selectedGameIndex].betsCommitting;
        let isTimeToShowSuccess = !!this.state.games[data.selectedGameIndex].betsCommitted;
        let isTimeToShowError = !!this.state.games[data.selectedGameIndex].betsFailedBeingCommitted;
        let betsToPlace = data.openBetsList.slice().filter((oBet) => oBet.game.channel === data.games[data.selectedGameIndex].channel && oBet.event.eventId === data.selectedEventId);

        return (<div className={style.bottomOutterContainer}>
            <div className={style.bottomInnerContainer}>
                <div id={'totalBetsText'} className={style.totalBetContainer}>
                    <div className={style.valuesContainer}>
                        <div className={style.totalBetText}>{getText('TOTAL_BETS', this.props.store)}</div>
                        <div
                            className={style.totalBetValue}>{getFormattedCurrency(this.props.store, totalBetsValue)}</div>
                    </div>
                </div>
            </div>

            <div className={style.bottomInnerContainer}>
                <div id={'placeBets'} className={style.bottomButtonContainer} onClick={() => betsToPlace.length > 0
                    ? this._placeBets(this.props.store.getState(), this.props.store)
                    : null}>
                    <div className={`${style.placeBetsButton} ${betsToPlace.length > 0
                        ? style.enabled
                        : null}`}>
                        {
                            !isTimeToShowLoading && !isTimeToShowSuccess && !isTimeToShowError
                                ? <div
                                    className={style.bottomBaseButtonBottomLine}>{getText('PLACE_BETS', this.props.store).toUpperCase()}</div>
                                : ''
                        }
                        {
                            isTimeToShowLoading
                                ? <div className={style.circleLoaderContainer}>
                                    <div className={style.circleLoader}/>
                                </div>
                                : ''
                        }
                        {
                            isTimeToShowSuccess
                                ? <div className={style.circleLoaderContainer}>
                                    <div className={style.checkmarkContainer}>
                                        <div className={style.checkmark}/>
                                    </div>
                                </div>
                                : ''
                        }
                        {
                            isTimeToShowError
                                ? <div className={style.circleLoaderContainer}>
                                    <div className={style.errormarkContainer}>
                                        <div className={style.errormark}/>
                                    </div>
                                </div>
                                : ''
                        }
                    </div>
                </div>
            </div>

        </div>);
    }

    _placeBets(store, dispatch) {
        if (OPERATOR.clientType === 'Simplified') {
            if (process.env.NODE_ENV !== 'development') {
                placeAndClearOpenBets(store.vpp.games[store.vpp.selectedGameIndex].channel, store.vpp.selectedEventId, undefined, store, dispatch);
            } else {
                fakePlaceBets(store.vpp.games[store.vpp.selectedGameIndex].channel, dispatch);
                dispatch(clearEventOpenBets(store.vpp.games[store.vpp.selectedGameIndex].channel, store.vpp.selectedEventId));
            }
        }
    }
}

export default connect(mapStateToProps)(TotalBets);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/desktop/components/totalBets.js